import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectContract, selectContractLoading, selectLoadingPAU } from '../../../redux/contract/selectors';
import { IconButton } from '@material-ui/core';
import iconEdit from '../../../images/iconEditarLead.svg';
import iconSave from '../../../images/iconGuardar.svg';
import { getContract, updateContractData, updateCustomerData } from '../../../redux/contract/thunks';
import { AditionalInfoForm } from './AditionalInfoForm';
import { convertToLocalTime } from '../../../commonFunctions/commonFunctions';
import dayjs from 'dayjs';
import { openModal } from '../../../redux/modal/modalSlice';

function AditionalInfo() {
  const dispatch = useDispatch();
  const contract = useSelector(selectContract);
  const loadingContract = useSelector(selectContractLoading);
  const loadingPAU = useSelector(selectLoadingPAU);
  const [contractFormData, setContractFormData] = useState({
    contractDataId: 0,
    userName: '',
    userSurnames: '',
    mobilePhone: '',
    phone: '',
    kilometrage: '',
    licenseNumber: '',
    email: '',
    driversClub: null,
    driversClubDate: '',

    cnpjMatriz: '',
    creditTotal: 0,
    creditUsed: 0,
    creditLimitDate: '',
    currentAccountLimit: 0,
    specialCheckLimit: 0,
    corporateCardLimit: 0,
    franchiseLimit: 0,

    services: [],
  });
  const [editMode, setEditMode] = useState(false);

  // Traspasa los datos cargados en redux al estado del componente para poder editarlos al detectar un contrato nuevo
  useEffect(() => {
    if (loadingContract === 'succeeded' && loadingPAU === 'succeeded' && contract.contractData) {
      let newDate = contract.contractData && contract.contractData?.driversClubDate !== '' ? new Date(dayjs(contract.contractData.driversClubDate, 'DD/MM/YYYY').format('YYYY/MM/DD')) : null;
      let newDateCreditLimitDate = contract.contractData && contract.customer.creditLimitDate !== '' ? new Date(dayjs(contract.customer.creditLimitDate, 'DD/MM/YYYY')) : null;

      setContractFormData((prevState) => ({
        ...prevState,
        ...contract.contractData,
        driversClubDate: newDate,
        kilometrage: contract.contractData?.kilometrage || '',

        cnpjMatriz: contract.customer.cnpjMatriz,
        creditTotal: contract.customer.creditTotal || 0,
        creditUsed: contract.customer.creditUsed || 0,
        creditLimitDate: newDateCreditLimitDate,
        currentAccountLimit: contract.customer.currentAccountLimit || 0,
        specialCheckLimit: contract.customer.specialCheckLimit || 0,
        corporateCardLimit: contract.customer.corporateCardLimit || 0,
        franchiseLimit: contract.customer.franchiseLimit || 0,

        services: contract?.services.map((s) => s.serviceId),
      }));
    }
  }, [contract]);

  function openEdit() {
    setEditMode(!editMode);
  }

  function toggleServiceId(filtered, id) {
    const index = filtered.indexOf(id);
    if (index === -1) {
      filtered.push(id);
    } else {
      filtered.splice(index, 1);
    }
    return filtered;
  }

  function handleChange(e, field) {
    let value;

    if (field != null) {
      if (field === 'driversClubDate') {
        value = convertToLocalTime(e);
      } else if (field === 'creditLimitDate') {
        value = convertToLocalTime(e);
      } else if (field.split('-')[0] === 'service') {
        value = toggleServiceId([...contractFormData.services], Number(field.split('-')[1]));
        field = 'services';
      } else {
        value = e;
      }

      setContractFormData((prevState) => ({
        ...prevState,
        [field]: value,
      }));
    }
  }

  //Gestiona el envío de datos del formulario
  async function handleSubmit() {
    if (contract.customerCNPJ && !contract.unassigned) {
      let submitData = { ...contractFormData };
      if (contractFormData.driversClubDate) {
        if (contractFormData.driversClubDate === '' || !contractFormData.driversClubDate) {
          submitData.driversClubDate = null;
        } else {
          submitData = { ...contractFormData, driversClubDate: dayjs(contractFormData.driversClubDate).format('YYYY/MM/DD') };
        }
      }
      if (contractFormData.kilometrage === '') {
        submitData.kilometrage = 0;
      }
      if (contractFormData.driversClub === '') {
        submitData.driversClub = null;
      }
      // await dispatch(updateContractData({ param: contract.id, body: submitData }));

      if (contractFormData.creditLimitDate) {
        if (contractFormData.creditLimitDate === '' || !contractFormData.creditLimitDate) {
          submitData.creditLimitDate = null;
        } else {
          submitData = { ...contractFormData, creditLimitDate: dayjs(contractFormData.creditLimitDate) };
        }
      }
      await dispatch(updateCustomerData({ param: contract.customerCNPJ, body: submitData }));
      dispatch(getContract({ query: '?cnpj=' + contract.customerCNPJ }));
      setEditMode(!editMode);
    } else {
      dispatch(openModal({ type: 'warning', message: 'Por favor, guarde la matricula o marque check de sin matricula' }));
    }
  }

  return (
    <>
      {contract.customerCNPJ && (
        <>
          <div className="button-wrapper" style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <IconButton disabled={!contract.customerCNPJ} onClick={editMode ? handleSubmit : openEdit}>
              <img width={20} src={editMode ? iconSave : iconEdit} alt={editMode ? 'Salvar' : 'Editar'} title={editMode ? 'Salvar' : 'Editar'} />
            </IconButton>
          </div>
          <div id="grid-contract-container">
            <AditionalInfoForm handleChange={handleChange} contractFormData={contractFormData} editMode={editMode}></AditionalInfoForm>
          </div>
        </>
      )}
    </>
  );
}

export { AditionalInfo };
